export const Separator = styled.div`
  border: 1px solid #ebebeb;
  margin-top: 10px;
  margin-bottom: 15px;
`;

export const DocumentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BreakFlexDiv = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const SuccessMessage = styled.h3`
  width: 270px;
  text-align: center;
  margin-top: 10px;
`;

export const SuccessGenerationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 130px;
  flex-direction: column !important;
`;

export const SuccessImage = styled.img`
  width: 160px;
  height: 166px;
`;

export const PdfPageBordered = styled.div`
  border: 1px solid lightgray;
  width: fit-content;
  min-width: 730px;
`;

export const PdfPageCounter = styled.div`
  justify-content: left;
  margin-right: auto;
  width: fit-content;
  padding: 10px 10px 10px 0px;
`;
